export const navigation = {
	'#aboutUs': 'About us',
	'#services': 'Services',
	'#references': 'References',
	'#career': 'Career',
	'#contact': 'Contact',
};
